export enum AttachmentSourceType {
  WORK_ORDER = "WORK_ORDER",
  QUOTATION = "QUOTATION",
  PETTY_WORK = "PETTY_WORK",
  AMC = "AMC",
}

/** 20 MB per file, matches the API limit. */
export const ATTACHMENT_MAX_FILE_BYTES = 20 * 1024 * 1024;

/** At most 10 files per upload call. */
export const ATTACHMENT_MAX_FILES_PER_UPLOAD = 10;

/** Accepted types per the API: images, PDF, Office docs, plain text, zip. */
export const ATTACHMENT_ACCEPT: Record<string, string[]> = {
  "image/jpeg": [".jpg", ".jpeg"],
  "image/png": [".png"],
  "image/webp": [".webp"],
  "application/pdf": [".pdf"],
  "application/msword": [".doc"],
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [".docx"],
  "application/vnd.ms-excel": [".xls"],
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx"],
  "application/vnd.ms-powerpoint": [".ppt"],
  "application/vnd.openxmlformats-officedocument.presentationml.presentation": [".pptx"],
  "text/plain": [".txt"],
  "application/zip": [".zip"],
};
